/* ============================================================
   MES MÉMOIRES — pages.js
   Navigation et footer communs à toutes les pages légales
   ============================================================ */

'use strict';

// ── NAV injection ─────────────────────────────────────────────
(function injectNav() {
  const nav = document.getElementById('nav');
  if (!nav) return;

  nav.innerHTML = `
    <a href="/" class="nav__logo">
      <img src="${(window.MEMOIRES_ASSETS && window.MEMOIRES_ASSETS.logo) || '/assets/img/logo-mm.png'}" alt="Mes Mémoires" class="nav__logo-img">
      <span class="nav__logo-text">Mes Mémoires</span>
    </a>
    <button class="nav__toggle" id="navToggle" aria-label="Ouvrir le menu">
      <span></span><span></span><span></span>
    </button>
    <ul class="nav__links" id="navLinks">
      <li><a href="/#concept"         class="nav__link">Concept</a></li>
      <li><a href="/pages/collections"              class="nav__link">Collections</a></li>
      <li><a href="/pages/creations-personnalisees" class="nav__link">Créations personnalisées</a></li>
      <li><a href="/pages/pourquoi-nos-creations-sont-uniques" class="nav__link">Pourquoi uniques</a></li>
      <li><a href="/pages/conciergerie"             class="nav__link">Conciergerie</a></li>
      <li><a href="/pages/audio"                       class="nav__link">Audio</a></li>
      <li><a href="/pages/l-histoire"               class="nav__link">L'Histoire</a></li>
      <li><a href="/pages/collections"              class="btn btn--gold btn--sm btn--3d nav__cta">Commander →</a></li>
    </ul>
  `;

  // Sticky scroll
  const onScroll = () => {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  nav.classList.add('scrolled'); // Toujours visible sur pages internes

  // Hamburger
  const toggle = document.getElementById('navToggle');
  const links  = document.getElementById('navLinks');
  if (!toggle || !links) return;
  if (toggle.dataset.navBound === 'true') return;
  toggle.dataset.navBound = 'true';
  toggle.setAttribute('aria-expanded', 'false');
  toggle.addEventListener('click', () => {
    const open = links.classList.toggle('open');
    toggle.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
  });
  links.querySelectorAll('a').forEach(l => {
    l.addEventListener('click', () => {
      links.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
  });
})();

// ── FOOTER injection ──────────────────────────────────────────
(function injectFooter() {
  const footer = document.getElementById('footer');
  if (!footer) return;

  footer.innerHTML = `
    <div class="footer__top">
      <div class="footer__brand">
        <img src="${(window.MEMOIRES_ASSETS && window.MEMOIRES_ASSETS.logo) || '/assets/img/logo-mm.png'}" alt="Logo Mes Mémoires" class="footer__logo-img">
        <p class="footer__logo">Mes Mémoires</p>
        <p class="footer__tagline">Maison de Correspondance Immersive</p>
        <p class="footer__desc">Donnons vie à vos histoires à travers des livres de correspondance uniques et authentiques, transmis aux générations futures.</p>
        <a href="https://www.instagram.com/mes_memoires?igsh=N3ljODAwZjhoanlr" target="_blank" rel="noopener" class="footer__social-link">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
            <rect x="2" y="2" width="20" height="20" rx="5" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
            <circle cx="12" cy="12" r="4" fill="none" stroke="#c9a84c" stroke-width="1.5"/>
            <circle cx="17.5" cy="6.5" r="1.2" fill="#c9a84c"/>
          </svg>
          @mes_memoires
        </a>
        <a href="https://www.tiktok.com/@mes_memoires?_r=1&_t=ZN-96x9gpKa1Q6" target="_blank" rel="noopener" class="footer__social-link footer__social-link--tiktok" aria-label="TikTok Mes Memoires">TikTok</a>
      </div>
      <div class="footer__links-grid">
<div class="footer__col">
        <h4 class="footer__col-title">Navigation</h4>
        <ul class="footer__links">
          <li><a href="/">Accueil</a></li>
          <li><a href="/#concept">Le concept</a></li>
          <li><a href="/pages/creations-personnalisees#accompagnement-editorial">Livre personnalisé</a></li>
          <li><a href="/pages/collections">Nos Collections</a></li>
          <li><a href="/pages/pourquoi-nos-creations-sont-uniques">Pourquoi uniques</a></li>
          <li><a href="/pages/conciergerie">Conciergerie</a></li>
          <li><a href="/#correspondances">Correspondances</a></li>
          <li><a href="/pages/audio">Audio exemple</a></li>
          <li><a href="/pages/l-histoire">L'Histoire</a></li>
        </ul>
      </div>
<div class="footer__col">
        <h4 class="footer__col-title">Informations</h4>
        <ul class="footer__links">
          <li><a href="/pages/mentions-legales">Mentions légales</a></li>
          <li><a href="/pages/conditions-generales-de-vente">Conditions générales de vente</a></li>
          <li><a href="/pages/conditions-generales-d-utilisation">Conditions générales d'utilisation</a></li>
          <li><a href="/pages/politique-de-confidentialite">Politique de confidentialité</a></li>
          <li><a href="/pages/politique-de-remboursement">Politique de remboursement</a></li>
          <li><a href="/pages/aide">Aide &amp; FAQ</a></li>
        </ul>
      </div>
<div class="footer__col">
        <h4 class="footer__col-title">Contact</h4>
        <ul class="footer__links">
          <li><a href="mailto:contact@mesmemoires.fr">contact@mesmemoires.fr</a></li>
          <li><a href="mailto:commande@mesmemoires.fr">commande@mesmemoires.fr</a></li>
          <li><a href="mailto:bonjour@mesmemoires.fr">bonjour@mesmemoires.fr</a></li>
          <li><a href="mailto:sav@mesmemoires.fr">sav@mesmemoires.fr</a></li>
          <li><a href="mailto:partenariat@mesmemoires.fr">partenariat@mesmemoires.fr</a></li>
        </ul>
      </div>
</div>
    </div>
    <div class="footer__divider"></div>
    <div class="footer__bottom">
      <p class="footer__price-note">Tous les prix sont indiqués en euros, toutes taxes comprises (TVA incluse). Livraison calculée au moment de la commande.</p>
      <p>© 2026 Mes Mémoires — Tous droits réservés</p>
      <p class="footer__made">Maison de Correspondance Immersive · France 🇫🇷</p>
    </div>
  `;
})();

// ── PAGE FADE IN ──────────────────────────────────────────────
(function initPageFade() {
  const showPage = () => { document.body.style.opacity = '1'; };
  document.body.style.opacity = '0';
  document.body.style.transition = 'opacity 0.4s ease';
  window.addEventListener('load', showPage, { once: true });
  document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(showPage), { once: true });
  window.setTimeout(showPage, 900);
  if (document.readyState !== 'loading') requestAnimationFrame(showPage);
})();
